import type { MutationHookOptions } from '@apollo/client'
import {
  DeleteTrainingRequestDocument,
  DeleteTrainingRequestMutation,
  DeleteTrainingRequestMutationVariables,
  MyRequestsDataCollectionDocument,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

type Options = MutationHookOptions<
  DeleteTrainingRequestMutation,
  DeleteTrainingRequestMutationVariables
>

export const useDeleteTrainingRequest = (options?: Options) => {
  const [deleteTrainingRequest, { loading }] = useMutation(DeleteTrainingRequestDocument, {
    ...options,
    extractorFn: (data) => data.trainingsMutations.deleteTrainingsTrainingRequest,
  })

  return {
    loading,
    delete(variables: DeleteTrainingRequestMutationVariables) {
      return deleteTrainingRequest({
        variables,
        awaitRefetchQueries: true,
        refetchQueries: [
          MyRequestsDataCollectionDocument,
          ...(Array.isArray(options?.refetchQueries) ? options.refetchQueries : []),
        ],
      })
    },
  }
}
